var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "page-link-filter initialized",
      style: _vm.containerStyles,
      attrs: { "data-callback-change": "CALENDAR-FILTER-CHANGE" },
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _c("div", { staticClass: "viewport" }, [
        _c(
          "div",
          { staticClass: "filter-area filter-calendar" },
          [
            _c(
              "h3",
              {
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.isFilterOpen = !_vm.isFilterOpen
                  },
                },
              },
              [_vm._v("Filter")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "drop-down-handle",
                class: { active: _vm.isFilterOpen },
                attrs: { title: "Filter", href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.isFilterOpen = !_vm.isFilterOpen
                  },
                },
              },
              [
                _c("svg", { staticClass: "open" }, [
                  _c("use", {
                    attrs: {
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      "xlink:href": "#symbol_filter_list",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("svg", { staticClass: "close" }, [
                  _c("use", {
                    attrs: {
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      "xlink:href": "#symbol_close_circle",
                    },
                  }),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "filter-count",
                class: { show: _vm.selectedFilterValues.length },
                attrs: { href: "#", title: "Clear Filters" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.clearFilters.apply(null, arguments)
                  },
                },
              },
              [
                _vm._v("\n        Clear Filter"),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.selectedFilterValues.length > 1,
                        expression: "selectedFilterValues.length > 1",
                      },
                    ],
                  },
                  [_vm._v("s")]
                ),
              ]
            ),
            _vm._v(" "),
            _c("widget-filters", {
              attrs: {
                filters: _vm.availableFilters,
                "is-filter-open": _vm.isFilterOpen,
              },
              on: {
                close: function ($event) {
                  _vm.isFilterOpen = false
                },
                "update-filter": _vm.updateFilter,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "clearme" }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }